exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".batch__tree[data-v-0548ec87]  .el-tree-node__label{color:var(--systemMainColor)}.batch__tree[data-v-0548ec87]  .el-tree-node__expand-icon{display:none}", ""]);

// exports
